import Axios, { AxiosResponse } from "axios"

export const getShareKeyProjectMiddleware = async (
  userId?: string,
  isLoading = false
) => {
  try {
    const params = new URLSearchParams()
    if (userId) {
      params.append("user_id", userId)
    }
    if (isLoading) {
      params.append("loading", "0")
    }

    const queryString = params.toString()
    const url = `/api/project/share-key${queryString ? `?${queryString}` : ""}`

    const response: AxiosResponse = await Axios.get(url)
    return response.data?.data
  } catch (error) {
    return null
  }
}
